import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import buildingsReducer from "./slices/buildingsSlice";
import guardsReducer from "./slices/guardSlice";
import tenantSlice from "./slices/tenantSlice";
import userReducer from "./slices/userSlice";
import adminReducer from "./slices/adminSlice";
import luggageReducer from "./slices/luggageSlice";
import visitorReducer from "./slices/visitorSlice";
import complaintsReducer from "./slices/complaintsSlice";
import superAdminReducer from "./slices/superAdminSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    buildings: buildingsReducer,
    guards: guardsReducer,
    tenants: tenantSlice,
    users: userReducer,
    superadmin: superAdminReducer,
    admin: adminReducer,
    luggage: luggageReducer,
    visitor: visitorReducer,
    complaints: complaintsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
